import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDBFq3iudfQn11XJwgkTrGT1uNzCCHCpPs",
  authDomain: "invoice-66feb.firebaseapp.com",
  projectId: "invoice-66feb",
  storageBucket: "invoice-66feb.firebasestorage.app",
  messagingSenderId: "531261018364",
  appId: "1:531261018364:web:cd3301f77533983be2c779",
  measurementId: "G-5M66N4Z6DV"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);